<template>
  <div id="app" style="height: auto">
    <el-container class="container">
      <el-header>
        <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
          <el-menu-item index="zd">快捷组队</el-menu-item>
          <el-menu-item index="cdw">查队伍</el-menu-item>
          <el-menu-item index="jsby">救赎边缘计算器</el-menu-item>
        </el-menu>
      </el-header>

      <el-main>
        <el-row>
          <component
            :is="componentMap[activeIndex]"
            :type="activeIndex"
            :img-map="imgMap"
          />
        </el-row>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import SalvationEdgeCalculator from '@/view/d2/conponents/salvation-edge-calculator.vue'
import FindGroup from '@/view/d2/conponents/find-group'
import CheckGroup from '@/view/d2/conponents/check-group'
import { dateDiffFormatter } from '@/utils/date'

export default {
  name: 'D2Home',
  components: { FindGroup, SalvationEdgeCalculator, CheckGroup },
  filters: {
    dateFormatter(value) {
      return dateDiffFormatter(value)
    }
  },
  data() {
    return {
      activeIndex: 'zd',
      imgMap: {},
      componentMap: {
        'zd': FindGroup,
        'cdw': CheckGroup,
        'jsby': SalvationEdgeCalculator
      }
    }
  },
  watch: {
    $route(to, from) {
      this.switchComponent(to.path)
    }
  },

  created() {
    this.init()
    this.refresh()
  },
  methods: {
    init() {
      this.switchComponent(this.$route.path)
    },
    handleSelect(index) {
      this.$router.push({ path: `/d2/${index}` })
    },
    refresh() {
    },
    switchComponent(originalPath) {
      const path = originalPath.replace('/d2/', '')
      if (this.componentMap[path]) {
        this.activeIndex = path
      } else {
        // 否则跳转到快捷组队
        this.activeIndex = 'zd'
      }
    }
  }
}
</script>

<style scoped lang="scss">
.container {
  padding: 0 100px;
}

.el-header {
  color: #333;
  line-height: 60px;
}
.el-aside {
  color: #333;
}

</style>
